import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { SupervisoryAccountSvg } from './svgs';

export const IconSupervisoryAccount: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={SupervisoryAccountSvg} viewBox="0 0 24 24" {...props} />;
};
